export default __webpack_public_path__ + "static/property-5d1ed69532ae58d4bfa497bc2c3a1230.png";